<template>
  <div class="enteringStudent">
    <el-page-header @back="goBack" content="新增试听"></el-page-header>

    <el-form
      ref="form"
      label-width="120px"
      class="form-style"
      :model="form"
      :rules="rules"
      size="small"
    >
      <el-row>
        <el-col :span="12">
          <div>
            <el-form-item label="学员姓名" required prop="realname">
              <el-input
                v-model="form.realname"
                style="width: 300px"
                placeholder="请输入学员姓名"
              ></el-input>
            </el-form-item>
          </div>
        </el-col>

        <el-col :span="12">
          <div>
            <el-form-item label="学员账号" required>
              <el-input
                v-model="form.parent_a_phone_num"
                style="width: 300px"
                placeholder="学员账号默认为家长A手机号"
                disabled
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <div>
            <el-form-item label="学员性别" required>
              <el-radio-group v-model="form.sex">
                <el-radio label="男"></el-radio>
                <el-radio label="女"></el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-form-item label="出生日期">
              <el-date-picker
                type="date"
                placeholder="请选择出生日期"
                v-model="form.birthday"
                style="width: 300px"
                value-format="yyyy-MM-dd"
                placement="bottom-start"
              ></el-date-picker>
            </el-form-item>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <div>
            <el-form-item label="所在学校">
              <el-input
                v-model="form.school_name"
                style="width: 300px"
                placeholder="请输入所在学校"
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div>
            <el-form-item label="在校年级" required>
              <el-select
                v-model="form.grade"
                placeholder="请选择在校年级"
                style="width: 300px"
              >
                <el-option label="幼儿园小班" :value="1"></el-option>
                <el-option label="幼儿园中班" :value="2"></el-option>
                <el-option label="幼儿园大班" :value="3"></el-option>
                <el-option label="一年级" :value="4"></el-option>
                <el-option label="二年级" :value="5"></el-option>
                <el-option label="三年级" :value="6"></el-option>
                <el-option label="四年级" :value="7"></el-option>
                <el-option label="五年级" :value="8"></el-option>
                <el-option label="六年级" :value="9"></el-option>
                <el-option label="初一" :value="10"></el-option>
                <el-option label="初二" :value="11"></el-option>
                <el-option label="初三" :value="12"></el-option>
                <el-option label="高一" :value="13"></el-option>
                <el-option label="高二" :value="14"></el-option>
                <el-option label="高三" :value="15"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="联系电话" required prop="parent_a_phone_num">
              <el-select v-model="form.parent_a" style="width: 100px">
                <el-option label="父亲" value="父亲"></el-option>
                <el-option label="母亲" value="母亲"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
              <el-input
                v-model="form.parent_a_phone_num"
                placeholder="请输入手机号"
                style="width: 180px; margin-left: 20px"
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple-light">
            <el-form-item label="家长微信" prop="parent_b_phone_num">
              <el-select v-model="form.parent_b" style="width: 100px">
                <el-option label="父亲" value="父亲"></el-option>
                <el-option label="母亲" value="母亲"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
              <el-input
                v-model="form.parent_b_phone_num"
                placeholder="请输入手机号"
                style="width: 180px; margin-left: 20px"
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <div>
            <el-form-item label="主责任人" required>
              <el-select
                v-model="form.leader"
                placeholder="请选择主责任人"
                style="width: 300px"
              >
                <el-option
                  v-for="item in user_list"
                  :key="item.id"
                  :label="item.realname + '(' + item.name + ')'"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>

        <el-col :span="12">
          <div>
            <el-form-item label="备注信息">
              <el-input
                style="width: 300px"
                type="textarea"
                v-model="form.remark"
              ></el-input>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
    </el-form>

    <p class="notice" v-if="$route.query.id">
      注意事项：
      <br />1、如修改学员手机号码，请输入正确手机号码，以保证学员能够正常登录
      <br />2、如更换的手机号不正确，有可能造成学员登录不上问题
      <br />3、因联系电话为学员登录账号，为保证信息正确，更换手机号时需要验证
      <br />4、想让学员快速进入班，可把学员所在班级中的班级码，通过微信等工具发送给学员，该学员凭班级码可在爱学习学生APP中快速进入班级
      <br />
    </p>

    <el-row>
      <el-col :span="24">
        <div class="step_btn">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-s-claim"
            @click="enterStudent('form')"
            >录入</el-button
          >
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getStudentDetail,
  updateStudentDetail,
  addAuditionStudent,
  getCampusUserList,
} from '@/api/educational'
import { getUserList } from '@/api/user'

export default {
  name: 'input-auditionstudent',
  data() {
    var validatePass = (rule, value, callback) => {
      if (!/^1[1234567890]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    var validatePhone = (rule, value, callback) => {
      if (value && !/^1[1234567890]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      form: {
        realname: '',
        sex: '',
        grade: '',
        parent_a: '',
        parent_a_phone_num: '',
        nickname: '',
        school_name: '',
        birthday: '',
        parent_b: '',
        parent_b_phone_num: '',
        state: '',
        leader: '',
        remark: '',
        educational_institution_campus_id: '',
      },
      user_list: [],
      school_list: [],
      tableDate: [],
      currentStep: 0,
      rules: {
        nickname: [
          {
            required: true,
            message: '请输入学生昵称',
            trigger: 'change',
          },
        ],

        realname: [
          {
            required: true,
            message: '请输入学员姓名',
            trigger: 'change',
          },
        ],

        parent_a_phone_num: [
          { required: true, message: '请输入联系电话', trigger: 'change' },
          { validator: validatePass, trigger: 'blur' },
        ],
        parent_b_phone_num: [{ validator: validatePhone, trigger: 'change' }],
      },
    }
  },
  watch: {
    '$store.state.user.selected_schools': {
      handler(newValue, oldValue) {
        console.log('校区监听')
        console.log(newValue)
        console.log(oldValue)
        if (newValue.length == 0) {
          this.$message.warning('目标校区不能为空')
        } else if (newValue.length > 1) {
          this.$message.warning('只能选择1个目标校区')
        } else {
          this.getCampusUserList()
        }
      },
      deep: true,
    },
  },
  mounted() {
    //权限验证

    if (
      this.$store.state.user.selected_schools.length == 0 ||
      this.$store.state.user.selected_schools.length > 1
    ) {
      this.$message.warning('请选择1个目标校区')
    } else {
      this.getCampusUserList()
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'auditionstudent' })
    },
    //获得学校员工账号
    getUserList() {
      getUserList({
        username: '',
        phone_num: '',
        state: '',
        role_id: '',
        page_no: '1',
        page_size: 20,
      }).then((res) => {
        console.log('员工列表')
        console.log(res)
        this.user_list = res.user_list
      })
    },

    //获得校区员工列表
    getCampusUserList() {
      getCampusUserList({
        campusId: this.$store.state.user.selected_schools[0],
      }).then((res) => {
        console.log('获得学校用户列表')
        console.log(res)
        this.user_list = res.campusUserList
      })
    },

    prenext() {
      if (this.currentStep-- < 1) this.currentStep = 0
    },
    next() {
      if (this.currentStep++ > 2) this.currentStep = 0
    },
    getStudentDetail() {
      getStudentDetail({
        student_id: this.$route.query.id,
      }).then((res) => {
        this.form.student_name = res.student_obj.name
        this.form.parent_a = res.student_obj.parent_a
        this.form.parent_a_phone_num = res.student_obj.parent_a_phone_num
        this.form.parent_b = res.student_obj.parent_b
        this.form.parent_b_phone_num = res.student_obj.parent_b_phone_num
        this.form.grade = res.student_obj.grade
        this.form.sex = res.student_obj.sex
        this.form.birthday = res.student_obj.birthday
        this.form.school_name = res.student_obj.school_name
      })
    },
    chooseClass(list) {
      this.tableDate = list
    },
    editStudent(index) {
      this.tableDate.splice(index, 1)
    },

    enterStudent(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.$route.query.id) {
            updateStudentDetail({
              student_id: this.$route.query.id,
              student_name: this.form.nickname,
              parent_a: this.form.parent_a,
              parent_a_phone_num: this.form.parent_a_phone_num,
              parent_b: this.form.parent_b,
              parent_b_phone_num: this.form.parent_b_phone_num,
              grade: this.form.grade,
              sex: this.form.sex,
              school_name: this.form.school_name,
              birthday: this.form.birthday,
            }).then(() => {
              this.$message.success('修改学员信息成功')
              this.$router.push({ name: 'students-management' })
            })
          } else {
            console.log('录入试听学员')
            console.log(formName)
            console.log(this.form)
            //TODO BUG 无校区字段
            addAuditionStudent({
              realname: this.form.realname,
              sex: this.form.sex,
              grade: this.form.grade,
              parent_a: this.form.parent_a,
              name: this.form.parent_a_phone_num,
              parent_a_phone_num: this.form.parent_a_phone_num,
              remark: this.form.remark,
              educational_institution_campus_id: this.$store.state.user
                .selected_schools[0],
            }).then((res) => {
              console.log(res)
              this.$message.success('试听学员录入成功!')
              this.$router.push({ name: 'auditionstudent' })
            })
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.enteringStudent {
  background-color: #fff;
  padding: 15px;
  margin: 15px;
  border-radius: 5px;
  box-sizing: border-box;

  .notice {
    font-size: 14px;
    line-height: 35px;
  }
  .steps {
    padding: 5px;
  }
  .step_btn {
    text-align: center;
  }
  .submit_btn {
    text-align: center;
  }
  .submit_info {
    margin-top: 20px;
    margin-bottom: 80px;
  }
}
</style>
